//Enable sidebar toggle
$(document).on('click', '#sidebarToggle, .sidebarToggle', function (e) {
    e.preventDefault();
    let $sidebar = $('#sidebarMobile')
    $sidebar.toggleClass('open')

    if ($sidebar.hasClass('open')){
        // $(this).find('i').removeClass('fa-bars').addClass('fa-times');
        $(this).find('i').removeClass('icon-feather-menu').addClass('icon-feather-x');
    }else{
        // $(this).find('i').removeClass('fa-times').addClass('fa-bars');
        $(this).find('i').removeClass('icon-feather-x').addClass('icon-feather-menu');
    }
});

$(document).on('click', '#sidebarMobile a.has-submenu', function (e) {
    e.preventDefault();
    let $parent = $(this).parent();
    $parent.toggleClass('active')
});
